import { css } from '@emotion/css';

import { Colors } from 'apps/shared/scripts/styles/constants';

export const upgradeCardClassName = css({
  background:
    'linear-gradient(to bottom right, #91d8fc, #b164e0 50%, #e64f6e 75%, #ff333e 95%)',
  color: Colors.White,
  '&:hover': {
    background:
      'linear-gradient(to bottom right, #91d8fc, #b164e0 40%, #e64f6e 65%, #ff333e 85%)',
  },
});
